import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

export default function ContentEditableText({
    value,
    canEdit,
    onChange,
    component = 'span',
    sx,
}) {
    const elementRef = useRef(null);

    useEffect(() => {
        const el = elementRef.current;
        if (!el) return;

        const nextValue = value ?? '';
        const isFocused = document.activeElement === el;
        if (isFocused) return;

        if (el.textContent !== nextValue) {
            el.textContent = nextValue;
        }
    }, [value]);

    return (
        <Box
            ref={elementRef}
            component={component}
            sx={sx}
            contentEditable={canEdit}
            suppressContentEditableWarning
            onInput={(e) => onChange?.(e.currentTarget.textContent ?? '')}
        />
    );
}